import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useRunAdbCommand() {
  const { send, isConnected, isOpen, connect } = useWebSocketContext();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const mountedRef = useRef(true);
  const connectionAttemptedRef = useRef(false);

  const runAdbCommand = useCallback(
    async ({ station_id, gun_id, command }) => {
      if (!mountedRef.current) return;

      setIsLoading(true);
      setError("");

      try {
        // Ensure WebSocket is connected
        if (!isConnected) {
          if (!connectionAttemptedRef.current) {
            connectionAttemptedRef.current = true;
            await connect();
          }

          await new Promise((resolve, reject) => {
            const start = Date.now();
            const interval = setInterval(() => {
              if (!mountedRef.current) {
                clearInterval(interval);
                reject(new Error("Component unmounted"));
              } else if (isOpen()) {
                clearInterval(interval);
                resolve(true);
              } else if (Date.now() - start > 10000) {
                clearInterval(interval);
                reject(new Error("WebSocket connection timeout"));
              }
            }, 100);
          });
        }

        // CMS request payload
        const request = {
          type: "cms_run_adb_command",
          payload: {
            station_id,
            gun_id,
            command, // e.g. "adb reboot"
          },
        };

        console.log("Sending ADB command:", request);

        const response = await send("cms_run_adb_command", request);
        console.log("Run ADB Command Response:", response);

        return { success: true, response };
      } catch (err) {
        setError(err.message);
        return { success: false, error: err.message };
      } finally {
        if (mountedRef.current) setIsLoading(false);
      }
    },
    [isConnected, isOpen, connect, send]
  );

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  return {
    runAdbCommand,
    isLoading,
    error,
  };
}
